import { isLocalUrl, openNewTab } from '../utils';

export default function () {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        createCustomTicketBtn(data.items[0]);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData;
    const isLocal = isLocalUrl(URL);

    if (!URL) {
      $widget.remove();
    }

    $widget.replaceWith(
      `<a class="button" id="customTicketButton" href="${URL}" tabindex="0" ${openNewTab(isLocal)}>${Title}</a>`,
    );
  }
}
